import React from 'react'
import ReactDOM from 'react-dom/client'
import { store } from '../../store'
import { Provider } from 'react-redux'
import WishlistContainer from './wishlist'

function Wrapper(props) {
    return (
        <Provider store={store}>
            <WishlistContainer {...props}/>
        </Provider>
    )
}

function wishlistContainer(element) {
  var options = element.dataset;
  var root = ReactDOM.createRoot(element);
  root.render(React.createElement(Wrapper, options));
}

document.addEventListener("DOMContentLoaded", function() {
  var elements = document.querySelectorAll('[data-wishlist-container]');
  elements.forEach(wishlistContainer);
});

